/* eslint-disable react/forbid-foreign-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LayoutProps from 'admin-components/proptypes/groups/layout';
import { FieldLabel } from './withLabel.styles';

const withLabel = (WrappedComponent) =>
  // eslint-disable-next-line react/display-name
  class extends Component {
    static propTypes = {
      label: PropTypes.node,
      ...LayoutProps.propTypes
    };

    static defaultProps = {
      ...LayoutProps.defaultProps,
      width: 12
    };

    static propDescriptions = {
      label: 'Label attached to the field #visual',
      ...LayoutProps.propDescriptions
    };

    render() {
      const { width, space, spaceWithin, borderWidth, label, marginBottom, ...inputProps } = this.props;

      return (
        <FieldLabel
          data-id="Label"
          data-testid="FieldLabel"
          {...{
            width,
            space,
            spaceWithin,
            borderWidth,
            type: inputProps.type,
            element: 'label'
          }}
          onClick={(e) => {
            if (!['file', 'radio'].includes(inputProps.type)) {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
        >
          <span style={{ marginBottom: 4 }}>{label}</span>
          <WrappedComponent {...inputProps} />
        </FieldLabel>
      );
    }
  };

export default withLabel;
